<div class="container footer">
  <div class="footer-top">
    <div nz-row>
      <div nz-col nzSpan="12" nzXs="24" nzMd="12">
        <div class="app-links">
          <img src="assets/icons/key_7_logo.svg" alt="Logo" />
          <ul class="links-list">
            <li>
              <a routerLink="">Terms of Use</a>
            </li>
            <li>
              <a routerLink="">Privacy Policy</a>
            </li>
            <li>
              <a routerLink="">Affiliation Program</a>
            </li>
            <li>
              <a routerLink="">Contact Us</a>
            </li>
            <li>
              <a routerLink="">Redeem a Gift Card</a>
            </li>
            <li>
              <a routerLink="">Latest Games News</a>
            </li>
          </ul>
        </div>
      </div>
      <div nz-col nzSpan="12" nzXs="24" nzMd="12">
        <div class="social-links">
          <div nz-flex nzGap="small">
            <a class="icon-btn">
              <span nz-icon nzType="ng-zorro:discord"></span>
            </a>
            <a class="icon-btn">
              <span nz-icon nzType="ng-zorro:twitter"></span>
            </a>
            <a class="icon-btn">
              <span nz-icon nzType="ng-zorro:instagram"></span>
            </a>
            <a class="icon-btn">
              <span nz-icon nzType="ng-zorro:facebook"></span>
            </a>
            <a class="icon-btn">
              <span nz-icon nzType="ng-zorro:youtube"></span>
            </a>
          </div>
        </div>
        <div class="footer-bottom-info">
          <p>
            All transactions are encrypted and processed through trusted payment
            gateways, ensuring your data stays safe. We comply with
            international data protection regulations, keeping your privacy
            secure. All trademarks and content are used under license, and
            unauthorized use is prohibited. For more information, please refer
            to our <a routerLink="">Terms & Conditions</a> and
            <a routerLink="">Privacy Policy</a>.
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="divider"></div>

  <div class="footer-bottom">
    <div class="copyright">
      <span>Copyright {{ '@2024 KEYS7' }} - All rights reserved</span>
    </div>
    <div class="link">
      <div class="link-item">
        <span nz-icon nzType="ng-zorro:location"></span>
        <span>USA</span>
      </div>
      <div class="link-item">
        <span nz-icon nzType="ng-zorro:language"></span>
        <span>English</span>
      </div>
      <div class="link-item">
        <span nz-icon nzType="ng-zorro:currency-exchange"></span>
        <span>USD</span>
      </div>
    </div>
  </div>
</div>
